module.exports = __webpack_public_path__ + "img/color-swatch-svgrepo-com.9f42838e.svg";